import { render, staticRenderFns } from "./addSmallWeChat.vue?vue&type=template&id=17171926"
import script from "./addSmallWeChat.vue?vue&type=script&lang=js"
export * from "./addSmallWeChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports